export const buildTimeline = (comments = []) => {
  return comments.map((c) => ({
    status: c.message?.split(": ").pop() ?? "-",
    label: c.message,
    user: c.user?.name ?? "-",
    time: new Date(c.created_at).toLocaleString("id-ID"),
  }));
};

export const formatDateLocal = (dateString, locale = "id-ID") => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  if (isNaN(date)) return "-";
  return date.toLocaleString(locale);
};
